import classes from './EventTileIcon.module.css';

interface EventTileIconProps {
  imgSrc: string;
  mode: 'active' | 'done' | 'inactive';
  onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
  title?: string;
}

export const EventTileIcon = (props: EventTileIconProps) => {
  const className = [classes.EventTileIcon, props.mode].join(' ');
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    console.log('EventTileIcon clicked');
    // if no onClick supplied, allow click event to propagate normally
    if (!props.onClick) {
      return;
    }
    // otherwise, prevent the default action and stop propagation
    e.preventDefault();
    e.stopPropagation();
    if (props.mode === 'active') {
      props.onClick(e);
    }
  };
  return (
    <a className={className} onClick={handleClick} title={props.title}>
      <img src={props.imgSrc} />
    </a>
  );
};
